/** Active Results-page filter labels sent with batch export for download filenames. */
export interface ViolationExportFilterSummary {
    jobs?: string[];
    statuses?: string[];
    time?: string[];
    guidelines?: string[];
    versions?: string[];
    asps?: string[];
    media?: string[];
    operationCompanies?: string[];
    creators?: string[];
    tags?: string[];
    categories?: string[];
    search?: string;
}

export interface BuildViolationExportFilterSummaryInput {
    selectedJobs: string[];
    jobIdToNameMap: Record<string, string>;
    selectedStatuses: string[];
    selectedTime: string[];
    selectedClients: string[];
    guidelineIdToNameMap: Record<string, string>;
    selectedVersions: string[];
    selectedAsps: string[];
    selectedMedia: string[];
    selectedOperationCompanies: string[];
    selectedCreators: string[];
    creatorIdToLabel: Record<string, string>;
    selectedTags: string[];
    selectedCategories: string[];
    categoryOptions: Array<{ label: string; value: string }>;
    searchTerm: string;
}

function nonEmpty(values: string[] | undefined): string[] | undefined {
    const filtered = (values || []).map((v) => v.trim()).filter(Boolean);
    return filtered.length > 0 ? filtered : undefined;
}

export function buildViolationExportFilterSummary(
    input: BuildViolationExportFilterSummaryInput
): ViolationExportFilterSummary | undefined {
    const categoryIdToLabel = Object.fromEntries(
        input.categoryOptions.map((c) => [c.value, c.label])
    );

    const summary: ViolationExportFilterSummary = {
        search: input.searchTerm.trim() || undefined,
        guidelines: nonEmpty(
            input.selectedClients.map((id) => input.guidelineIdToNameMap[id] || id)
        ),
        versions: nonEmpty(input.selectedVersions.map((v) => `v${v}`)),
        asps: nonEmpty(input.selectedAsps),
        media: nonEmpty(input.selectedMedia),
        operationCompanies: nonEmpty(input.selectedOperationCompanies),
        creators: nonEmpty(
            input.selectedCreators.map((id) => input.creatorIdToLabel[id] || id)
        ),
        jobs: nonEmpty(
            input.selectedJobs.map((id) => input.jobIdToNameMap[id] || id)
        ),
        statuses: nonEmpty(input.selectedStatuses),
        tags: nonEmpty(input.selectedTags),
        time: nonEmpty(input.selectedTime),
        categories: nonEmpty(
            input.selectedCategories.map((id) => categoryIdToLabel[id] || id)
        ),
    };

    const hasValue = Object.values(summary).some((v) =>
        Array.isArray(v) ? v.length > 0 : Boolean(v)
    );
    return hasValue ? summary : undefined;
}
